module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-wrap--medium u-mt8"
  }, [(_vm.squads.length) ? _c('div', {
    staticClass: "SquadListing"
  }, [_c('span', [_vm._v("Showing " + _vm._s(_vm.squads.length) + " results")]), _vm._v(" "), _c('transition-group', {
    staticClass: "SquadListing-items",
    attrs: {
      "tag": "ul",
      "name": "squad-listing"
    }
  }, _vm._l((_vm.sortedSquads), function(squad, index) {
    return _c('li', {
      key: squad._uid,
      staticClass: "SquadListing-items u-mt2"
    }, [_c('squad-listing-item', {
      attrs: {
        "squad": squad
      }
    })], 1)
  }))], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40efc2c8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/squad-listing.vue
// module id = 330
// module chunks = 0